import Resource from '@/api/resource'
import request from '@/utils/request'

class VRCode extends Resource {
  constructor() {
    super('vr-code')
  }

  generate() {
    return request({
      url: '/generate-vr-code',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  checkStatus() {
    return request({
      url: '/check-code-status',
      method: 'get',
    })
  }

  cancel() {
    return request({
      url: '/cancel-vr-code',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
    })
  }

  login(code) {
    return request({
      url: '/login-with-code',
      method: 'post',
      data: { code },
      headers: { 'Content-Type': 'application/json' },
    })
  }
}

export default VRCode
